import util from '@bmp-vue/core/api/util'

const controller = 'SLC0001'
export default Object.assign({}, util.GetCrud(controller, null), {
  Get (dto) {
    return util.Axios.GetAll(controller + '/Get', dto)
  }
})
